(function(){
  "use strict";

  /* ---------- Header solid on scroll ---------- */
  var header = document.getElementById('siteHeader');
  var headerAlwaysSolid = !document.body.classList.contains('template-index');
  function onScroll(){
    if(!header) return;
    if(headerAlwaysSolid || window.scrollY > 60){ header.classList.add('solid'); }
    else { header.classList.remove('solid'); }
  }
  if(!headerAlwaysSolid){ window.addEventListener('scroll', onScroll, {passive:true}); }
  onScroll();

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById('mobileNav');
  var burgerBtn = document.getElementById('burgerBtn');
  var mnavClose = document.getElementById('mnavClose');
  if(burgerBtn) burgerBtn.addEventListener('click', function(){ mobileNav.classList.add('open'); });
  if(mnavClose) mnavClose.addEventListener('click', function(){ mobileNav.classList.remove('open'); });
  document.querySelectorAll('.mnav-link').forEach(function(a){
    a.addEventListener('click', function(){ mobileNav.classList.remove('open'); });
  });

  /* ---------- Smooth scroll to in-page sections ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', function(e){
    if(e.defaultPrevented) return;
    if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest('a[href]');
    if(!link) return;
    if(link.target && link.target !== '_self') return;

    var href = link.getAttribute('href') || '';
    var at = href.indexOf('#');
    if(at < 0) return;

    var id = href.slice(at + 1);
    if(!id) return;

    var target = document.getElementById(id);
    if(!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    if(window.history && history.replaceState){ history.replaceState(null, '', '#' + id); }
  });

  /* ---------- Reveal on scroll ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); } });
  }, {threshold:0.15});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ---------- Accordions (product page) ---------- */
  document.querySelectorAll('.acc-item button').forEach(function(btn){
    btn.addEventListener('click', function(){ btn.parentElement.classList.toggle('open'); });
  });

  /* ---------- Image carousels (product cards and product page) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function(root){
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pc-slide'));
    if(slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pc-dot]'));
    var index = slides.findIndex(function(s){ return s.classList.contains('is-active'); });
    if(index < 0) index = 0;

    function paint(){
      slides.forEach(function(s, n){ s.classList.toggle('is-active', n === index); });
      dots.forEach(function(d, n){ d.classList.toggle('is-active', n === index); });
    }

    function go(i){
      var next = (i + slides.length) % slides.length;
      if(next === index) return;
      index = next;
      paint();
      root.dispatchEvent(new CustomEvent('carousel:change', {detail:{index:index}}));
    }

    paint();

    root.addEventListener('carousel:goto', function(e){ go(e.detail.index); });

    root.querySelectorAll('[data-pc-prev]').forEach(function(btn){
      btn.addEventListener('click', function(e){ e.preventDefault(); go(index - 1); });
    });
    root.querySelectorAll('[data-pc-next]').forEach(function(btn){
      btn.addEventListener('click', function(e){ e.preventDefault(); go(index + 1); });
    });
    dots.forEach(function(d, n){
      d.addEventListener('click', function(e){ e.preventDefault(); go(n); });
    });

    var startX = null, startY = null, swiped = false;
    root.addEventListener('touchstart', function(e){
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiped = false;
    }, {passive:true});
    root.addEventListener('touchmove', function(e){
      if(startX === null) return;
      if(Math.abs(e.touches[0].clientX - startX) > 10 || Math.abs(e.touches[0].clientY - startY) > 10) swiped = true;
    }, {passive:true});
    root.addEventListener('touchend', function(e){
      if(startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ go(index + (dx < 0 ? 1 : -1)); }
      startX = null; startY = null;
    }, {passive:true});
    root.addEventListener('click', function(e){
      if(swiped){ e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);
  });

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(msg){
    var t = document.getElementById('toast');
    if(!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 3000);
  }

  /* ---------- Cart drawer open/close ---------- */
  var overlay = document.getElementById('overlay');
  var cartDrawer = document.getElementById('cartDrawer');
  function openCart(){ if(cartDrawer){ cartDrawer.classList.add('open'); overlay.classList.add('open'); refreshCart(); } }
  function closeCart(){ if(cartDrawer){ cartDrawer.classList.remove('open'); overlay.classList.remove('open'); } }
  var cartOpenBtn = document.getElementById('cartOpenBtn');
  var cartCloseBtn = document.getElementById('cartCloseBtn');
  if(cartOpenBtn) cartOpenBtn.addEventListener('click', openCart);
  if(cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if(overlay) overlay.addEventListener('click', closeCart);

  /* ---------- Shopify Ajax Cart ---------- */
  function renderCartDrawer(cart){
    var itemsEl = document.getElementById('cartItems');
    var footEl = document.getElementById('cartFoot');
    var countEl = document.getElementById('cartCount');
    if(!itemsEl) return;
    if(countEl) countEl.textContent = cart.item_count;

    if(cart.item_count === 0){
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      itemsEl.innerHTML = '<div class="cart-empty">Tu carrito está vacío.<br><br><a href="' + rootUrl + '#coleccion" class="btn-link" style="color:var(--ink)">Ver colección</a></div>';
      itemsEl.querySelector('.cart-empty a').addEventListener('click', closeCart);
      if(footEl) footEl.style.display = 'none';
      return;
    }
    if(footEl) footEl.style.display = 'block';

    itemsEl.innerHTML = cart.items.map(function(item){
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_160x$1$2') : '';
      return '' +
        '<div class="cart-item">' +
          (img ? '<img src="'+img+'" alt="'+(item.product_title||'')+'">' : '') +
          '<div class="meta">' +
            '<p class="n">'+item.product_title+'</p>' +
            '<p class="v">'+(item.variant_title ? item.variant_title.replace(' / ', ' · ') : '')+'</p>' +
            '<div class="qty-row">' +
              '<button data-act="dec" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Restar">–</button>' +
              '<span>'+item.quantity+'</span>' +
              '<button data-act="inc" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Sumar">+</button>' +
              '<span class="price" style="margin-left:auto">'+formatMoney(item.final_line_price)+'</span>' +
            '</div>' +
            '<button class="remove" data-act="rm" data-key="'+item.key+'">Quitar</button>' +
          '</div>' +
        '</div>';
    }).join('');

    var sub = document.getElementById('cartSubtotal');
    var tot = document.getElementById('cartTotal');
    if(sub) sub.textContent = formatMoney(cart.total_price);
    if(tot) tot.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll('button[data-act]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-key');
        var act = btn.getAttribute('data-act');
        var qty = parseInt(btn.getAttribute('data-qty'),10) || 0;
        if(act === 'inc'){ changeLine(key, qty + 1); }
        if(act === 'dec'){ changeLine(key, qty - 1); }
        if(act === 'rm'){ changeLine(key, 0); }
      });
    });
  }

  function formatMoney(cents){
    var v = (cents/100);
    try{
      return v.toLocaleString('es-UY', {style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'UYU', maximumFractionDigits:0});
    }catch(e){
      return '$' + Math.round(v);
    }
  }

  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(renderCartDrawer)
      .catch(function(){});
  }

  function changeLine(key, quantity){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:quantity})
    })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(quantity > 0){
          var line = null;
          for(var i = 0; i < cart.items.length; i++){
            if(cart.items[i].key === key){ line = cart.items[i]; break; }
          }
          if(line && line.quantity < quantity){
            showToast('No hay más unidades disponibles de ese talle.');
          }
        }
        renderCartDrawer(cart);
      })
      .catch(function(){});
  }

  function addToCart(variantId, quantity){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: quantity}]})
    }).then(function(r){
      if(!r.ok){ return r.json().then(function(err){ throw err; }); }
      return r.json();
    });
  }

  refreshCart();

  /* ---------- Cart page line controls ---------- */
  document.querySelectorAll('.cart-line-inc,.cart-line-dec,.cart-line-remove').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.getAttribute('data-key');
      var qty = parseInt(btn.getAttribute('data-qty'),10) || 0;
      var quantity = btn.classList.contains('cart-line-inc') ? qty+1 : btn.classList.contains('cart-line-dec') ? qty-1 : 0;
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:key, quantity:quantity})
      }).then(function(){ window.location.reload(); });
    });
  });

  /* ---------- Product page: colour, size, stock, media ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function(root){
    var section = root.closest('[id^="shopify-section-"]');
    var sectionId = section ? section.id.replace('shopify-section-','') : '';
    var dataScript = document.getElementById('variantData-' + sectionId);
    if(!dataScript) return;

    var variants;
    try{ variants = JSON.parse(dataScript.textContent); }catch(e){ return; }
    if(!variants || !variants.length) return;

    var colorRow = root.querySelector('.color-row');
    var sizeRow = root.querySelector('.variant-row');
    var img = document.getElementById('pdpImg-' + sectionId);
    var priceEl = document.getElementById('pdpPrice-' + sectionId);
    var colorNameEl = document.getElementById('colorName-' + sectionId);
    var variantIdInput = document.getElementById('pdpVariantId-' + sectionId);
    var addBtn = document.getElementById('pdpAddBtn-' + sectionId);
    var stockEl = document.getElementById('pdpStock-' + sectionId);
    var qtyVal = document.getElementById('qtyVal-' + sectionId);
    var qtyInput = document.getElementById('pdpQty-' + sectionId);
    var minusBtn = document.getElementById('qtyMinus-' + sectionId);
    var plusBtn = document.getElementById('qtyPlus-' + sectionId);
    var form = root.querySelector('form');

    var mediaCarousel = root.querySelector('.pdp-media[data-carousel]');
    var slideColors = mediaCarousel
      ? Array.prototype.slice.call(mediaCarousel.querySelectorAll('.pc-slide')).map(function(s){ return s.getAttribute('data-color') || ''; })
      : [];
    var syncingMedia = false;

    var firstColorBtn = colorRow ? colorRow.querySelector('.swatch.active') : null;
    var state = {
      color: firstColorBtn ? firstColorBtn.getAttribute('data-color-value') : (variants[0] ? variants[0].color : null),
      size: null,
      qty: 1
    };

    function find(color, size){
      for(var i = 0; i < variants.length; i++){
        if(variants[i].color === color && variants[i].size === size) return variants[i];
      }
      return null;
    }

    function firstOfColor(color){
      for(var i = 0; i < variants.length; i++){
        if(variants[i].color === color) return variants[i];
      }
      return null;
    }

    function stockOf(v){
      if(!v) return 0;
      if(v.managed !== 'shopify') return Infinity;
      if(v.policy === 'continue') return Infinity;
      return v.qty > 0 ? v.qty : 0;
    }

    function setQty(n){
      state.qty = n;
      if(qtyVal) qtyVal.textContent = n;
      if(qtyInput) qtyInput.value = n;
    }

    function refreshSizes(){
      if(!sizeRow) return;
      sizeRow.querySelectorAll('button').forEach(function(btn){
        var size = btn.getAttribute('data-size-value');
        var v = find(state.color, size);
        var ok = !!(v && v.available);
        btn.disabled = !ok;
        btn.classList.toggle('is-out', !ok);
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if(!ok && state.size === size){ state.size = null; }
        btn.classList.toggle('active', state.size === size);
      });
    }

    function refreshCta(){
      var v = state.size ? find(state.color, state.size) : null;
      if(v){
        if(variantIdInput) variantIdInput.value = v.id;
        if(priceEl) priceEl.textContent = formatMoney(v.price);
      }
      if(!addBtn) return;

      if(!state.size){
        addBtn.disabled = true;
        addBtn.textContent = 'Elegí un talle';
        if(stockEl){ stockEl.textContent = ''; stockEl.classList.remove('is-out'); }
        return;
      }
      if(!v || !v.available){
        addBtn.disabled = true;
        addBtn.textContent = 'Sin stock';
        if(stockEl){ stockEl.textContent = 'Este talle está agotado.'; stockEl.classList.add('is-out'); }
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Agregar al carrito';
      var max = stockOf(v);
      if(max !== Infinity && state.qty > max) setQty(max);
      if(stockEl){
        stockEl.classList.remove('is-out');
        stockEl.textContent = (max !== Infinity && max <= 5) ? ('Quedan ' + max + (max === 1 ? ' unidad.' : ' unidades.')) : '';
      }
    }

    function showImage(v){
      if(!v || !v.img || !img) return;
      if(img.getAttribute('src') === v.img) return;
      img.classList.add('fading');
      setTimeout(function(){
        img.src = v.img;
        if(v.alt) img.alt = v.alt;
        img.classList.remove('fading');
      }, 180);
    }

    function applyColor(color){
      state.color = color;
      if(colorRow){
        colorRow.querySelectorAll('.swatch').forEach(function(b){
          b.classList.toggle('active', b.getAttribute('data-color-value') === color);
        });
      }
      if(colorNameEl) colorNameEl.textContent = color;
      setQty(1);
      refreshSizes();
      refreshCta();
    }

    function showColorMedia(color){
      if(mediaCarousel){
        var idx = slideColors.indexOf(color);
        if(idx < 0) return;
        syncingMedia = true;
        mediaCarousel.dispatchEvent(new CustomEvent('carousel:goto', {detail:{index: idx}}));
        syncingMedia = false;
        return;
      }
      showImage(firstOfColor(color));
    }

    if(mediaCarousel){
      mediaCarousel.addEventListener('carousel:change', function(e){
        if(syncingMedia) return;
        var color = slideColors[e.detail.index];
        if(!color || color === state.color) return;
        applyColor(color);
      });
    }

    if(colorRow){
      colorRow.querySelectorAll('.swatch').forEach(function(btn){
        btn.addEventListener('click', function(){
          var color = btn.getAttribute('data-color-value');
          if(color === state.color) return;
          applyColor(color);
          showColorMedia(color);
        });
      });
    }

    if(sizeRow){
      sizeRow.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(btn.disabled) return;
          state.size = btn.getAttribute('data-size-value');
          sizeRow.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          setQty(1);
          refreshCta();
        });
      });
    }

    if(minusBtn) minusBtn.addEventListener('click', function(){
      setQty(Math.max(1, state.qty - 1));
    });

    if(plusBtn) plusBtn.addEventListener('click', function(){
      if(!state.size){ showToast('Elegí un talle primero.'); return; }
      var max = stockOf(find(state.color, state.size));
      if(max !== Infinity && state.qty + 1 > max){
        showToast('Solo quedan ' + max + (max === 1 ? ' unidad' : ' unidades') + ' de ese talle.');
        return;
      }
      setQty(state.qty + 1);
    });

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if(!state.size){ showToast('Elegí un talle para continuar.'); return; }
        var v = find(state.color, state.size);
        if(!v || !v.available){ showToast('Ese talle está agotado.'); return; }
        var max = stockOf(v);
        if(max !== Infinity && state.qty > max){
          setQty(max);
          showToast('Solo quedan ' + max + (max === 1 ? ' unidad' : ' unidades') + ' de ese talle.');
          return;
        }
        addBtn.disabled = true;
        addToCart(v.id, state.qty).then(function(){
          addBtn.disabled = false;
          showToast('Producto agregado al carrito');
          openCart();
        }).catch(function(err){
          addBtn.disabled = false;
          var msg = (err && (err.description || err.message)) || 'No se pudo agregar al carrito';
          showToast(msg);
          refreshCart();
        });
      });
    }

    refreshSizes();
    refreshCta();
  });

})();
